import { Action } from '@ngrx/store';
import { ICorrelationParams } from './correlation-params.interface';

export type AggregatableAction = Action & {
  correlationParams?: ICorrelationParams;
};

export type FailActionForAggregation = Action & {
  error?: Error;
  correlationParams?: ICorrelationParams;
};
